import { useAuth } from "../../../../context";
import { useMutation, useQuery } from "react-query";
import { UseOfSoldProducts } from "../../../../api";

export const useOfSoldProductsKeys = {
  items: () => ["useOfSoldProductsItems"]
};

export function useGetUseOfSoldProductsItems(params, config) {
  const { callApi } = useAuth();
  return useQuery(
    [...useOfSoldProductsKeys.items(), params.queryParams.page, params.queryParams.size, params.queryParams.sort],
    () => callApi(UseOfSoldProducts.getUseOfSoldProductsItems, params), config);
}

export function useAddUseOfSoldProductsItems(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, data }) =>
    callApi(UseOfSoldProducts.addUseOfSoldProductsItems, { questionnaireId, data }), config);
}

export function useUpdateUseOfSoldProductsItem(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, recordId, data }) =>
    callApi(UseOfSoldProducts.updateUseOfSoldProductsItem, { questionnaireId, recordId, data }), config);
}

export function useDeleteUseOfSoldProductsItem(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, recordId }) =>
    callApi(UseOfSoldProducts.deleteUseOfSoldProductsItem, { questionnaireId, recordId }), config);
}

export function useImportUseOfSoldProducts(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, data }) =>
    callApi(UseOfSoldProducts.importUseOfSoldProducts, { questionnaireId, data }), config);
}

export function useUpdateUseOfSoldProducts(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, id, data }) =>
    callApi(UseOfSoldProducts.updateUseOfSoldProducts, { questionnaireId, data }), config);
}

export function useDownloadUseOfSoldProductsTemplate(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId }) =>
    callApi(UseOfSoldProducts.getUseOfSoldProductsTemplate, questionnaireId), config);
}
